import { useState } from "react";
import { usePageMeta } from "@/lib/meta";
import { HtmlBlock, scrollToEl } from "@/components/HtmlBlock";
import ContactSection from "@/components/ContactSection";
import mainHtml from "@/gen/partner_main";
import footerHtml from "@/gen/partner_footer";

const rootStyle = { background: "#0C0E12", color: "#F2F4F6", fontFamily: "'IBM Plex Sans',system-ui,sans-serif", lineHeight: 1.6 };

export default function PartnerPage() {
  usePageMeta("Partner");
  const [interest, setInterest] = useState("");

  const onAnchor = (href, a) => {
    if (href === "#contact") {
      const sec = a.closest("[id]");
      if (sec && ["invest", "operate", "pray"].includes(sec.id)) setInterest(sec.id);
      const el = document.getElementById("contact");
      if (el) scrollToEl(el);
      return true;
    }
    return false;
  };

  return (
    <div data-testid="partner-page">
      <HtmlBlock html={mainHtml} onAnchor={onAnchor} testId="partner-main" />
      <div style={rootStyle}>
        <ContactSection interest={interest} />
      </div>
      <HtmlBlock html={footerHtml} testId="partner-footer" />
    </div>
  );
}
